import React, { FC } from 'react';
import { Skeleton } from '@mui/material';
import { StyleBody, StyleBox, StyleBoxToolbar, StyleHeading, StyleSkeletonTable } from './styled';
import { SkeletonProps } from '../types';

const HistorySkeleton: FC<SkeletonProps> = ({ heading, isLoading, children }) => {
  return isLoading ? (
    <>
      <StyleSkeletonTable>
        <StyleHeading>
          {heading ? (
            <StyleBoxToolbar>
              <Skeleton variant='text' width={100} height={40} />
            </StyleBoxToolbar>
          ) : (
            ''
          )}

          <StyleBox>
            <Skeleton variant='text' width={80} height={40} />
            <Skeleton variant='text' width={80} height={40} />
            <Skeleton variant='text' width={80} height={40} />
            <Skeleton variant='text' width={80} height={40} />
          </StyleBox>
        </StyleHeading>

        <StyleBody>
          <Skeleton variant='text' width={80} height={40} />
          <Skeleton variant='text' width={80} height={40} />
          <Skeleton variant='text' width={80} height={40} />
          <Skeleton variant='text' width={80} height={40} />
        </StyleBody>
      </StyleSkeletonTable>
    </>
  ) : (
    children
  );
};

export default HistorySkeleton;
